<template>
    <b-card no-body>
        <!-- Card body -->
        <b-card-body>
            <div class="loader" v-if="loading"></div>
            <b-card-title class="h2 mb-0">Create your art book </b-card-title>
            <small class="text-muted">
              Your editorial assistant: {{ newBook.editor }}
            </small>
            <b-card-text class="mt-4">

                <b-row>
                    <b-col md="12">

                      <base-input :rules="{ required: { allowFalse: false } }" name="Publishing agreement">
                        <b-form-checkbox v-model="confirmcontract">
                          <span>I hereby confirm the publishing agreement for my book. ( <a href="#!" @click="retrieveDocument()">Download publishing agreement here </a>)</span>
                        </b-form-checkbox>
                      </base-input>

                    </b-col>
                </b-row>

            </b-card-text>
            <a href="#!" @click="startPublication" class="btn btn-dark">Start my publication</a>
        </b-card-body>
    </b-card>
  
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import moment from 'moment'
  
  export default {
    name: "new-photo-book-card",
    data() {
      return {
        loading: false,
        confirmcontract: false,
        unprocessable: false,
        newBook: [],
        document: [],
      };
    },
    props: {
        photoBookId: '',
    },
    methods: {
      startPublication(){
        if(this.confirmcontract){
            this.agreeProject();
        }
      },
      agreeProject() {
        this.loading = true;
        this.$api.agreePhotoBook(this.photoBookId)
          .then((response) => {
            console.log(response);
            this.newBook = response.data;
            console.log(this.newBook);
            if(response.data.code == 502){
                this.unprocessable = true;
            }
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
            if(!this.unprocessable){
                this.$router.push({ name: 'Artist Book Wizard', params: { token: this.photoBookId }})
            }
          });
      },
      retrieveBook() {
            this.loading = true;
            this.$api.getPhotoBook(this.photoBookId)
                .then((response) => {
                    console.log(response);
                    this.newBook = response.data;
                    console.log(this.newBook);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false
                });
        },
      retrieveDocument() {
        this.loading = true;
        this.$api.getDocument("publishing_contract")
          .then((response) => {
            this.document = response.data;
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false;
            this.retrieveDocumentFile();
          });
      },
      retrieveDocumentFile() {
       // this.retrieveDocument();
        this.loading = true;
        this.$api.getDocumentFile("publishing_contract")
          .then((response) => {
            console.log(response);
            this.forceFileDownload(response, this.document.filename);
          })
          .catch((e) => {
            console.log(e);
          }).finally(() => {
            this.loading = false
          });
      },
      forceFileDownload(response, title) {
        console.log(title)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', title)
        document.body.appendChild(link)
        link.click()
      },
      formatDate(date) {
        return moment(date).format("Do MMM YYYY")
      },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        bookLoaded: function () {
            return this.newBook ? true : false;
        }
    },
    mounted() {
        this.retrieveBook();
    },
  };
  </script>
  <style></style>